export default "__VITE_ASSET__DdiiCfbs__"